import * as Scrivito from "scrivito";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap";
import I18n from "^/config/i18n";
import { isBrowser } from "^/utils/isBrowser";

Scrivito.provideComponent("LoginWidget", ({ _widget }) => {
  let isLoggedIn = false;
  if (typeof window !== "undefined") {
    isLoggedIn =
      (isBrowser && window.sessionStorage.getItem("hs-intranet.loggedIn")) ||
      false;
  }
  if (isLoggedIn) {
    // read user data, rewrite url
    return null;
  }

  return (
    <Scrivito.WidgetTag className="d-md-flex justify-content-md-center">
      <Card>
        <CardBody>
          <CardTitle tag="h5">{I18n.t("loginform.title")}</CardTitle>
          <Form>
            <FormGroup>
              <Label for="login">{I18n.t("loginform.login.label")}</Label>
              <Input
                name="login"
                placeholder={I18n.t("loginform.login.placeholder")}
                type="text"
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">{I18n.t("loginform.password.label")}</Label>
              <Input
                name="password"
                placeholder={I18n.t("loginform.password.placeholder")}
                type="password"
              />
            </FormGroup>
            <FormGroup>
              <Button>{I18n.t("loginform.button.title")}</Button>
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    </Scrivito.WidgetTag>
  );
});
